export const getOrganizationRoles = () => ({
    method: 'get',
    url: 'permissions/v1/roles',
});
